import { useLazyQuery } from '@apollo/client';
import { GET_UOM_LIST } from '@bechtel/ht-clients-common';
import { SearchUomResult } from '@bechtel/ht-types';
import { useCallback } from 'react';

export const useGetUomList = () => {
  const [getUomListQuery, { data, loading, error, refetch, networkStatus, fetchMore }] = useLazyQuery<{
    searchUoms: SearchUomResult;
  }>(GET_UOM_LIST, {
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
  });
  const getUomList = useCallback(
    (onComplete?: (data) => void) => {
      getUomListQuery({
        onCompleted: (data) => {
          if (onComplete) {
            onComplete(data);
          }
        },
        fetchPolicy: 'cache-first',
      });
    },
    [getUomListQuery]
  );

  return { getUomList, data, loading, error, refetch, networkStatus, fetchMore };
};
